import { render, staticRenderFns } from "./LaoHD.vue?vue&type=template&id=4f983b9a&"
import script from "./LaoHD.vue?vue&type=script&lang=js&"
export * from "./LaoHD.vue?vue&type=script&lang=js&"
import style0 from "./LaoHD.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports